//Local Url :
// let baseURL = "http://192.168.10.112:3006";

//Dev Url:
let baseURL = "https://qa-api.farmkar.com.pk"

//QA Url:
// let baseURL = process.env.REACT_APP_BASE_URL_BACKEND;

export { baseURL };
